import { createTextColumn } from '@ipfabric/utils';
import { createFrontendOnlyColumn } from 'components/Table/columns/frontendOnlyColumn';
import { PolicyRowActions } from '../shared/PolicyRowActions';
import type { PolicyRowMode } from '../shared/policyFormMode';
import type { WriteScopes } from '../shared/useWriteScopes';
import type { DataPolicy } from './dataPoliciesApi';

export type DataPoliciesTableRow = {
  id: string;
  name: string;
  condition: string;
  impact: string;
  isSystem: boolean;
  policy: DataPolicy;
};

type DataPoliciesTableHandlers = {
  scopes: WriteScopes;
  onOpen: (policy: DataPolicy, mode: PolicyRowMode) => void;
  onDelete: (policy: DataPolicy) => void;
};

export const createDataPoliciesTableColumns = ({
  scopes,
  onOpen,
  onDelete,
}: DataPoliciesTableHandlers) => [
  createTextColumn<DataPoliciesTableRow>({
    key: 'id',
    title: 'ID',
    hidden: true,
  }),
  createTextColumn<DataPoliciesTableRow>({ key: 'name', title: 'Policy name' }),
  createTextColumn<DataPoliciesTableRow>({
    key: 'condition',
    title: 'Condition',
  }),
  createTextColumn<DataPoliciesTableRow>({ key: 'impact', title: 'Impact' }),
  createFrontendOnlyColumn<DataPoliciesTableRow>({
    key: 'actions',
    title: 'Actions',
    disabledSort: true,
    webDependencies: ['id'],
    render: (row) => (
      <PolicyRowActions
        id={row.id}
        testIdPrefix='data-policies'
        readOnly={row.isSystem}
        scopes={scopes}
        onView={() => onOpen(row.policy, 'view')}
        onEdit={() => onOpen(row.policy, 'edit')}
        onDuplicate={() => onOpen(row.policy, 'duplicate')}
        onDelete={() => onDelete(row.policy)}
      />
    ),
  }),
];
